import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { activeSnack } from './common';
import { del, get, put, post } from '../http';

// --- API THUNKS START ---
export const createWallet = createAsyncThunk(
  'wallets/create',
  async ({ state, dispatch, handleClose, handleClear, memberId }) => {
    try {
      const URL = `wallet-address/new/${memberId}`;
      const response = await post(URL, state);
      if (response) {
        handleClose();
        handleClear();
        dispatch(activeSnack({ type: 'success', message: 'wallet created successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const updateWalletDetails = createAsyncThunk(
  'wallets/update',
  async ({ state, walletId, dispatch, navigate }) => {
    try {
      const URL = `/wallet/admin/${walletId}`;
      const response = await put(URL, state);
      if (response) {
        if (navigate) {
          navigate();
        }
        dispatch(activeSnack({ type: 'success', message: 'Wallet updated Successfully' }));
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const getAllWallet = createAsyncThunk(
  'wallets/list',
  async ({ page, search, dispatch, limit, sortBy, sortDirection }) => {
    try {
      const URL = `/wallet/admin/all?page=${page && page}&search=${search && search}&limit=${
        limit && limit
      }&sortBy=${sortBy && sortBy}&sortDirection=${sortDirection && sortDirection}`;
      const URL_DROPDOWN = `/wallet/admin/all`;
      const response = await get(page ? URL : URL_DROPDOWN);
      if (response) {
        return {
          list: response?.wallets,
          total: response?.total,
        };
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const getWalletDetails = createAsyncThunk(
  'wallets/single',
  async ({ walletId, dispatch }) => {
    try {
      const response = await get(`/wallet/admin/${walletId}/`);
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const deleteWallet = createAsyncThunk(
  'wallets/delete',
  async ({ walletId, dispatch, handleCloseDeleteDialog }) => {
    try {
      const response = await del(`/wallet/admin/walletId/`);
      if (response) {
        handleCloseDeleteDialog();
        dispatch(activeSnack({ type: 'success', message: 'Wallet deleted Successfully' }));
        return response?._id;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
export const getAllMemberWalletAddress = createAsyncThunk(
  'wallet-address/list',
  async ({ page, limit, search, dispatch }) => {
    try {
      const response = await get(
        `/member/wallet-address?page=${page && page}&limit=${limit || 5}&search=${search && search}`
      );
      console.log(response);
      if (response) {
        return response;
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
// --- REDUX SLICE START ---
const covertToJSON = (data) => JSON.parse(JSON.stringify(data));

export const walletSlice = createSlice({
  name: 'wallet',
  initialState: {
    loading: false,
    error: {},
    // wallet
    walletList: {},
    walletDropList: [],
    walletDetails: {},
    walletAddress: {},
  },
  reducers: {
    clearWalletError: (state) => {
      state.error = true;
    },
  },
  extraReducers: {
    // create wallet details
    [createWallet.pending]: (state) => {
      state.loading = true;
    },
    [createWallet.fulfilled]: (state, action) => {
      const jsonState = covertToJSON(state)?.walletList;
      const modifiedWalletList = {
        ...jsonState,
        list: Array.isArray(jsonState?.list)
          ? // eslint-disable-next-line no-unsafe-optional-chaining
            [...jsonState?.list, action.payload]
          : [action.payload],
      };
      state.loading = false;
      state.walletDetails = action.payload;
      state.walletList = modifiedWalletList;
      state.error = {};
    },
    [createWallet.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // get all wallet
    [getAllWallet.pending]: (state) => {
      state.loading = true;
    },
    [getAllWallet.fulfilled]: (state, action) => {
      state.loading = false;
      state.walletList = action.payload;
      state.error = {};
    },
    [getAllWallet.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    // get single wallet details
    [getWalletDetails.pending]: (state) => {
      state.loading = true;
    },
    [getWalletDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.walletDetails = action.payload;
      state.error = {};
    },
    [getWalletDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    // update wallet details
    [updateWalletDetails.pending]: (state) => {
      state.loading = true;
    },
    [updateWalletDetails.fulfilled]: (state, action) => {
      state.loading = false;
      state.walletDetails = action.payload;
      state.error = {};
    },
    [updateWalletDetails.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },

    [deleteWallet.pending]: (state) => {
      state.loading = true;
    },
    [deleteWallet.fulfilled]: (state, action) => {
      const jsonState = covertToJSON(state)?.walletList;
      const modifiedWalletList = {
        ...jsonState,
        list: jsonState.list?.filter((wallet) => wallet._id !== action.payload),
      };
      state.loading = false;
      state.walletList = modifiedWalletList;
      state.error = {};
    },
    [deleteWallet.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
    // member wallet  address
    [getAllMemberWalletAddress.pending]: (state) => {
      state.loading = true;
    },
    [getAllMemberWalletAddress.fulfilled]: (state, action) => {
      state.loading = false;
      state.walletAddress = action.payload;
      state.error = {};
    },
    [getAllMemberWalletAddress.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.error;
    },
  },
});
export const { clearWalletError } = walletSlice.actions;

export default walletSlice.reducer;
